import { createClient } from "@supabase/supabase-js";

let supabasePromise;

export function getSupabase() {
  if (!supabasePromise) {
    supabasePromise = (async () => {
      const r = await fetch("/api/config");
      if (!r.ok) throw new Error("Could not load app config from server");
      const cfg = await r.json();
      if (!cfg.supabaseUrl || !cfg.supabaseAnonKey) {
        throw new Error("Secure sign-in is not configured yet.");
      }
      return createClient(cfg.supabaseUrl, cfg.supabaseAnonKey, {
        auth: { persistSession: true, autoRefreshToken: true },
      });
    })();
  }
  return supabasePromise;
}

export async function authedFetch(path, options = {}) {
  const sb = await getSupabase();
  const { data: { session } } = await sb.auth.getSession();
  const headers = new Headers(options.headers || {});
  if (session?.access_token) headers.set("Authorization", `Bearer ${session.access_token}`);
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  if (!headers.has("Content-Type") && options.body && !isFormData) headers.set("Content-Type", "application/json");
  const res = await fetch(path, { ...options, headers });
  if (res.status === 401) {
    // Session expired — redirect silently to the landing page without showing an error
    window.location.href = "/";
    return;
  }
  const isJson = res.headers.get("content-type")?.includes("application/json");
  const body = isJson ? await res.json() : await res.text();
  if (res.status === 403 && isJson && body?.code === "EMAIL_VERIFICATION_REQUIRED") {
    window.location.href = "/verify-email";
    return;
  }
  if (!res.ok) {
    const msg = isJson ? body?.error || JSON.stringify(body) : String(body);
    throw new Error(msg);
  }
  return body;
}
